"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


// Sends whose files are still uploading. A send with files posts nothing until
// every file is up (sendConversationAttachments), so leaving the page in that
// window loses the whole send with no failed row to retry. The apps read this
// to warn before leaving and to show "Uploading 5 of 8…".














const sends = new Map()
const listeners = new Set()
let nextId = 0
// Snapshots change identity only when something changed, as
// useSyncExternalStore requires.
let version = 0
const summaries = new Map()

const notify = () => {
  version++
  listeners.forEach(listener => listener())
}

 const pendingSendsStore = {
  /** Starts tracking one send of `total` files; returns how to report on it. */
  begin: (conversationKey, total) => {
    const id = nextId++
    sends.set(id, { conversationKey, total, uploaded: 0 })
    notify()
    return {
      fileUploaded: () => {
        const send = sends.get(id)
        if (!send) return
        send.uploaded = Math.min(send.uploaded + 1, send.total)
        notify()
      },
      end: () => {
        if (sends.delete(id)) notify()
      },
    }
  },

  hasPending: () => sends.size > 0,

  /** Files uploaded and in total across a chat's pending sends, or null. */
  summary: (conversationKey) => {
    const cached = summaries.get(conversationKey)
    if (_optionalChain([cached, 'optionalAccess', _ => _.version]) === version) return cached.summary
    let uploaded = 0
    let total = 0
    let found = false
    for (const send of sends.values()) {
      if (send.conversationKey !== conversationKey) continue
      found = true
      uploaded += send.uploaded
      total += send.total
    }
    const summary = found ? { uploaded, total } : null
    summaries.set(conversationKey, { version, summary })
    return summary
  },

  subscribe: (listener) => {
    listeners.add(listener)
    return () => { listeners.delete(listener) }
  },
}; exports.pendingSendsStore = pendingSendsStore

 const useHasPendingSends = () =>
  _react.useSyncExternalStore.call(void 0, exports.pendingSendsStore.subscribe, exports.pendingSendsStore.hasPending, exports.pendingSendsStore.hasPending); exports.useHasPendingSends = useHasPendingSends

 const usePendingSendsSummary = (conversationKey) => {
  const getSnapshot = _react.useCallback.call(void 0, 
    () => (conversationKey ? exports.pendingSendsStore.summary(conversationKey) : null),
    [conversationKey],
  )
  return _react.useSyncExternalStore.call(void 0, exports.pendingSendsStore.subscribe, getSnapshot, getSnapshot)
}; exports.usePendingSendsSummary = usePendingSendsSummary
